import React, { useState } from 'react';
import client from '../../../../lib/client';
import { logger } from '../../../../lib/helpers';
import {
  accountMembersQuery,
  accountQuery,
  inviteUserToAccountMutation
} from '../../../../queries/account';
import {
  InviteUserToAccountMutation,
  InviteUserToAccountMutationVariables
} from '../../../../queries/__generated__/InviteUserToAccountMutation';
import { Input } from '../../../forms';
import { Modal } from '../../../ui';

interface InviteToSpaceModalProps {
  closeModal: () => void;
  account: {
    id: string;
  };
}

const InviteToSpaceModal: React.FC<InviteToSpaceModalProps> = ({ closeModal, account }) => {
  const [inviteeName, setInviteeName] = useState('');
  const [inviteeEmail, setInviteeEmail] = useState('');

  const sendInvite = async (event: React.SyntheticEvent) => {
    event.preventDefault();

    const res = await client.mutate<
      InviteUserToAccountMutation,
      InviteUserToAccountMutationVariables
    >({
      mutation: inviteUserToAccountMutation,
      variables: {
        input: {
          accountId: account.id,
          email: inviteeEmail,
          displayName: inviteeName
        }
      },
      refetchQueries: [
        {
          query: accountQuery,
          variables: {
            id: account.id
          }
        },
        {
          query: accountMembersQuery,
          variables: { input: { accountId: account.id } }
        }
      ]
    });

    const invitation = res.data!.inviteUserToAccount.invitation;
    logger(`${window.location.host}/join/${invitation!.inviteCode}`);

    closeModal();
  };

  return (
    <Modal closeModal={closeModal}>
      <div className="pt3">
        <h1 className="tc f5 fw6 mv3">Invite a Member to This Space</h1>

        <form onSubmit={event => sendInvite(event)}>
          <div className="ph3 ph4-ns mb4">
            <Input
              placeholder="Email"
              value={inviteeEmail}
              onChange={e => setInviteeEmail(e.target.value)}
              type="email"
              className="mb2"
              data-testid="email-input"
              autoFocus
            />

            <Input
              placeholder="Name"
              value={inviteeName}
              onChange={e => setInviteeName(e.target.value)}
              type="text"
              className="mb2"
              data-testid="name-input"
            />
          </div>

          <div className="flex ">
            <button
              className="w-100 bt br b--light-gray f6 pa3 tc blue hover-navy"
              type="button"
              data-testid="cancel-button"
              onClick={closeModal}
            >
              Cancel
            </button>

            <button
              className="w-100 bt b--light-gray f6 fw5 pa3 tc blue hover-navy"
              type="submit"
              disabled={!inviteeEmail}
              data-testid="send-invite-button"
            >
              Send
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default InviteToSpaceModal;
